<template>
  <div v-if="isLoading" class="loader-container">
    <v-progress-circular
      :size="50"
      class="loader"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>

  <div v-else>
    <div class="text-subtitle-1 bold">Últimos eventos do conjunto</div>

    <v-timeline
      dense
      clipped
      v-if="events.length > 0"
    >
      <v-timeline-item
        v-for="event in events"
        :key="event.id"
        class="mb-4"
        color="gray"
        small
      >
        <v-row justify="space-between">
          <v-col
            class="subtitle-2 bold"
            cols="7"
            v-text="formatDescriptionFor(event)"
          ></v-col>
          <v-col
            class="py-0 body-2"
            cols="7"
            v-text="formatDetailsFor(event)"
          ></v-col>
          <v-col
            class="text-right body-2"
            cols="5"
            v-text="formatDateFor(event)"
          ></v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>

    <div class="body-2 mt-2" v-else>
      Este conjunto ainda não possui eventos
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { EVENT_TYPE } from '@/module/event/domain/model/event';

export default {
  name: 'PumpMotoTimeline',
  props: {
    fetchEvents: {
      type: Function,
      required: true
    },
    pumpMoto: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    events: []
  }),
  mounted() {
    this._fetchEvents()
  },
  methods: {
    formatDateFor(event) {
      return dayjs(event.created_date).format("DD/MM/YYYY HH:mm")
    },
    formatDescriptionFor(event) {
      switch (event.type) {
        case EVENT_TYPE.PUMP_MOTO_STATE_CHANGE:
          return "Mudança de estado do conjunto"
        default:
          return ""
      }
    },
    formatDetailsFor(event) {
      let description = event.description.replaceAll('true', 'Ligado')
      description = description.replaceAll('false', 'Desligado')

      return description
    },
    async _fetchEvents() {
      this.isLoading = true

      this.events = await this.fetchEvents(this.pumpMoto)

      this.isLoading = false
    }
  },
  watch: {
    pumpMoto: function(value) {
      this._fetchEvents()
    }
  }
}
</script>

<style>
.loader-container {
  height: 350px;
}
.loader {
  left: 50%;
  top: 50%
}
</style>
